import React from 'react';
import { IconCheck, IconCircleNotch, IconXmark, IconClock } from '../ui-kit/icons';

// Defines the icon uses for the list item
const statusToIcon = {
  acknowledged: IconCheck,
  pending: IconCircleNotch,
  rejected: IconXmark,
  expired: IconClock
};

// Defines in which cases a spinner is returned
const animatedIcon = {
  acknowledged: null,
  pending: 'fa-spinner fa-spin',
  rejected: null
};

export const IncidentResponderStatusIcon = ({ status }) => {
  const title = I18n.t(`classy_enum.incidents/incident_response_status.${status}`);
  const Icon = statusToIcon[status];
  if (!Icon) {
    return null;
  }
  return <Icon className={animatedIcon[status]} title={title} />;
};
